import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import ViewModal from "components/modal/ViewContact";
import { notifyError, notifySuccess } from "utils/toast";
import ContactServices from "services/ContactServices";

import ShowContact from "components/table/showContact";
import { FiEye } from "react-icons/fi";

const ContactTable = ({ contact, perpage, currentPage, tab, setContactData,hideEdit }) => {
  const { serviceId, handleView, title } = useToggleDrawer();
  const { setIsUpdate } = useContext(SidebarContext);

  const handleContact = async (id, currentStatus) => {
    const newStatus = !currentStatus;
    try {
      const response = await ContactServices.updateContactStatus(id, {
        status: newStatus,
      });

      if (response.status) {
        notifySuccess("Status Updated Successfully");


        setContactData(prev =>
          prev.map(item =>
            item.id === id ? { ...item, status: newStatus } : item
          )
        );
      } else {
        notifyError("Failed to update status");
      }
    } catch (error) {
      notifyError("An error occurred while updating status");
    }
  };


  return (
    <>
      <ViewModal id={serviceId} title={title} data={contact} />

      <TableBody>
        {contact?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-sm text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-sm text-center">{data.name}</TableCell>
            <TableCell className="text-sm text-center"> {new Date(data.added_date).toLocaleString()}</TableCell>
            <TableCell className="text-sm text-center">
              {data.email_id}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data.mobile_no}
            </TableCell>

            <TableCell className="text-center">
               {hideEdit?(
              <ShowContact
                id={data.id}
                active={data.status}
                handleContact={handleContact}
              />
               ):(<span>-</span>)}

            </TableCell>

            <TableCell className="text-center">
             
                 <button
                onClick={() => handleView(data.id, "Contact Details")}
                className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
              >
                <Tooltip
                  id={data.id}
                  Icon={FiEye}
                  title="ViewOrder"
                  bgColor="#34D399"
                />
              </button>

             
             
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default ContactTable;
